 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER2701GIFTBEFOREPARTING from '@/components/0_chapter2701giftbeforeparting'
 import A_CHAPTER2702MYSTERIOUSSKYEVILEMPEROR from '@/components/1_chapter2702mysteriousskyevilemperor'
 import A_CHAPTER2703CONFRONTATIONFORTHESAMEREALM from '@/components/2_chapter2703confrontationforthesamerealm'
 import A_CHAPTER2704ACHOICEOFHELPLESSNESS from '@/components/3_chapter2704achoiceofhelplessness'
 import A_CHAPTER2705RISKINGONESLIFE from '@/components/4_chapter2705riskingoneslife'
 import A_CHAPTER2706STRUGGLEWITHALLYOURMIGHT from '@/components/5_chapter2706strugglewithallyourmight'
 import A_CHAPTER2707HEAVENLYSOUND from '@/components/6_chapter2707heavenlysound'
 import A_CHAPTER2708TIBETANDRAGONCROUCHINGTIGER from '@/components/7_chapter2708tibetandragoncrouchingtiger'
 import A_CHAPTER2709ESCAPEFROMDEATH from '@/components/8_chapter2709escapefromdeath'
 import A_CHAPTER2710FULLOFGRATITUDE from '@/components/9_chapter2710fullofgratitude'
 import A0_CHAPTER2711THREEBREAKSOFLIFE from '@/components/10_chapter2711threebreaksoflife'
 import A1_CHAPTER2712THETRUTHOFANNIHILATION from '@/components/11_chapter2712thetruthofannihilation'
 import A2_CHAPTER2713THESECONDHEAVENLYLAYER from '@/components/12_chapter2713thesecondheavenlylayer'
 import A3_CHAPTER2714AMUTUALFRIENDSHIPWITHOUTAFIGHT from '@/components/13_chapter2714amutualfriendshipwithoutafight'
 import A4_CHAPTER2715DRAGONCAVE from '@/components/14_chapter2715dragoncave'
 import A5_CHAPTER2716UNKNOWNDANGER from '@/components/15_chapter2716unknowndanger'
 import A6_CHAPTER2717CULINARYPAVILION from '@/components/16_chapter2717culinarypavilion'
 import A7_CHAPTER2718ODONTOPLASTY from '@/components/17_chapter2718odontoplasty'
 import A8_CHAPTER2719CONGREGATIONSOFTHEASCENDANTS from '@/components/18_chapter2719congregationsoftheascendants'
 import A9_CHAPTER2720DEVOIDHEAVENLYBOOK from '@/components/19_chapter2720devoidheavenlybook'
 import A0_CHAPTER2721STRUGGLEFOR from '@/components/20_chapter2721strugglefor'
 import A1_CHAPTER2722EXALTEDCELESTIALSIXDESIRE from '@/components/21_chapter2722exaltedcelestialsixdesire'
 import A2_CHAPTER2723CONCEALMENTOFIDENTITY from '@/components/22_chapter2723concealmentofidentity'
 import A3_CHAPTER2724FOUND from '@/components/23_chapter2724found'
 import A4_CHAPTER2725FOLLOWCLOSELY from '@/components/24_chapter2725followclosely'
 import A5_CHAPTER2726DRACONICBEAST from '@/components/25_chapter2726draconicbeast'
 import A6_CHAPTER2727INSPECTION from '@/components/26_chapter2727inspection'
 import A7_CHAPTER2728DARKDECISION from '@/components/27_chapter2728darkdecision'
 import A8_CHAPTER2729WAITINGALONGTIME from '@/components/28_chapter2729waitingalongtime'
 import A9_CHAPTER2730HEADTOHEADCONTENTION from '@/components/29_chapter2730headtoheadcontention'
 import A0_CHAPTER2731OUTBREAKOFBLACKWATER from '@/components/30_chapter2731outbreakofblackwater'
 import A1_CHAPTER2732CARDCOLLISION from '@/components/31_chapter2732cardcollision'
 import A2_CHAPTER2733GIVEITTOME from '@/components/32_chapter2733giveittome'
 import A3_CHAPTER2734GENERALLEDGER from '@/components/33_chapter2734generalledger'
 import A4_CHAPTER2735BULLMAN from '@/components/34_chapter2735bullman'
 import A5_CHAPTER2736MATRIXBREAKDOWN from '@/components/35_chapter2736matrixbreakdown'
 import A6_CHAPTER2737ENEMYSLAUGHTERING from '@/components/36_chapter2737enemyslaughtering'
 import A7_CHAPTER2738TOBRANDISHTHESWORDBRAZENLY from '@/components/37_chapter2738tobrandishtheswordbrazenly'
 import A8_CHAPTER2739FACESMACKING from '@/components/38_chapter2739facesmacking'
 import A9_CHAPTER2740IMPRINT from '@/components/39_chapter2740imprint'
 import A0_CHAPTER2741GREATEMPEROROFTHESEVENSENTIMENTS from '@/components/40_chapter2741greatemperorofthesevensentiments'
 import A1_CHAPTER2742ADARKRUMOR from '@/components/41_chapter2742adarkrumor'
 import A2_CHAPTER2743CARMINE from '@/components/42_chapter2743carmine'
 import A3_CHAPTER2744FOURKINDSOFDANGER from '@/components/43_chapter2744fourkindsofdanger'
 import A4_CHAPTER2745DRAGONSMIGHT from '@/components/44_chapter2745dragonsmight'
 import A5_CHAPTER2746HOPEFORLIFE from '@/components/45_chapter2746hopeforlife'
 import A6_CHAPTER2747SINOPOTAMON from '@/components/46_chapter2747sinopotamon'
 import A7_CHAPTER2748NOWAYBACK from '@/components/47_chapter2748nowayback'
 import A8_CHAPTER2749FADEDBLACKDRAGON from '@/components/48_chapter2749fadedblackdragon'
 import A9_CHAPTER2750REVERSESCALE from '@/components/49_chapter2750reversescale'
 import A0_CHAPTER2751THEMETAMORPHOSEBOOKOFHEAVENSBOOK from '@/components/50_chapter2751themetamorphosebookofheavensbook'
 import A1_CHAPTER2752DEMONICQIBODYTEMPERING from '@/components/51_chapter2752demonicqibodytempering'
 import A2_CHAPTER2753INDESTRUCTIBLEDIAMOND from '@/components/52_chapter2753indestructiblediamond'
 import A3_CHAPTER2754THICKFIGHTINGSPIRIT from '@/components/53_chapter2754thickfightingspirit'
 import A4_CHAPTER2755LATE from '@/components/54_chapter2755late'
 import A5_CHAPTER2756OPROL from '@/components/55_chapter2756oprol'
 import A6_CHAPTER2757PEACHOUTOFTHEWORLD from '@/components/56_chapter2757peachoutoftheworld'
 import A7_CHAPTER2758DISTRESS from '@/components/57_chapter2758distress'
 import A8_CHAPTER2759ITISIMPERATIVE from '@/components/58_chapter2759itisimperative'
 import A9_CHAPTER2760WINDREGION from '@/components/59_chapter2760windregion'
 import A0_CHAPTER2761AOLIESAPPEARANCE from '@/components/60_chapter2761aoliesappearance'
 import A1_CHAPTER2762BRIGHTCONTRAST from '@/components/61_chapter2762brightcontrast'
 import A2_CHAPTER2763FAILURE from '@/components/62_chapter2763failure'
 import A3_CHAPTER2764SPIRITUALLIGHTSEMERGE from '@/components/63_chapter2764spirituallightsemerge'
 import A4_CHAPTER2765WHOISANANT from '@/components/64_chapter2765whoisanant'
 import A5_CHAPTER2766MADSTRUGGLE from '@/components/65_chapter2766madstruggle'
 import A6_CHAPTER2767WORLDCRASH from '@/components/66_chapter2767worldcrash'
 import A7_CHAPTER2768OXAPROXIL from '@/components/67_chapter2768oxaproxil'
 import A8_CHAPTER2769AOLIEFALLING from '@/components/68_chapter2769aoliefalling'
 import A9_CHAPTER2770DISPUTE from '@/components/69_chapter2770dispute'
 import A0_CHAPTER2771MIXEDFEELINGS from '@/components/70_chapter2771mixedfeelings'
 import A1_CHAPTER2772AVOIDINGSHARPEDGE from '@/components/71_chapter2772avoidingsharpedge'
 import A2_CHAPTER2773ESCAPEBYFORCE from '@/components/72_chapter2773escapebyforce'
 import A3_CHAPTER2774SEETHESUNAGAIN from '@/components/73_chapter2774seethesunagain'
 import A4_CHAPTER2775FENGLIUYUNSAN from '@/components/74_chapter2775fengliuyunsan'
 import A5_CHAPTER2776FAREWELLTOALTERINGTEETH from '@/components/75_chapter2776farewelltoalteringteeth'
 import A6_CHAPTER2777LONGMENMESSAGE from '@/components/76_chapter2777longmenmessage'
 import A7_CHAPTER2778TOOTHTRANSFERRING from '@/components/77_chapter2778toothtransferring'
 import A8_CHAPTER2779UNIVERSALBIRTH from '@/components/78_chapter2779universalbirth'
 import A9_CHAPTER2780TWOEAGLESWITHONEARROW from '@/components/79_chapter2780twoeagleswithonearrow'
 import A0_CHAPTER2781LOTUSSEEDFORMATION from '@/components/80_chapter2781lotusseedformation'
 import A1_CHAPTER2782BLOODYTRUTH from '@/components/81_chapter2782bloodytruth'
 import A2_CHAPTER2783SIXTHLEVELOFTHEDRAGONCAVE from '@/components/82_chapter2783sixthlevelofthedragoncave'
 import A3_CHAPTER2784PHENOMENALERUPTION from '@/components/83_chapter2784phenomenaleruption'
 import A4_CHAPTER2785MIXINGWITHTHEDRAGONISLAND from '@/components/84_chapter2785mixingwiththedragonisland'
 import A5_CHAPTER2786LONGMENPRESENT from '@/components/85_chapter2786longmenpresent'
 import A6_CHAPTER2787TWINDRAGONDAY from '@/components/86_chapter2787twindragonday'
 import A7_CHAPTER2788FIGHTINGBEGINS from '@/components/87_chapter2788fightingbegins'
 import A8_CHAPTER2789DENGLONGMEN from '@/components/88_chapter2789denglongmen'
 import A9_CHAPTER2790COMPETITIONSFORKARMICLUCK from '@/components/89_chapter2790competitionsforkarmicluck'
 import A0_CHAPTER2791BLOODLINEPROMOTION from '@/components/90_chapter2791bloodlinepromotion'
 import A1_CHAPTER2792COUNTERATTACK from '@/components/91_chapter2792counterattack'
 import A2_CHAPTER2793HATINGSEED from '@/components/92_chapter2793hatingseed'
 import A3_CHAPTER2794CELESTIALLORDOFTHESTARS from '@/components/93_chapter2794celestiallordofthestars'
 import A4_CHAPTER2795FALSEBRAVADO from '@/components/94_chapter2795falsebravado'
 import A5_CHAPTER2796THETIDEHASDROPPED from '@/components/95_chapter2796thetidehasdropped'
 import A6_CHAPTER2797DOGBITEDOG from '@/components/96_chapter2797dogbitedog'
 import A7_CHAPTER2798KARMICKARMICKARMICDRAGON from '@/components/97_chapter2798karmickarmickarmicdragon'
 import A8_CHAPTER2799MASSEMERGENCE from '@/components/98_chapter2799massemergence'
 import A9_CHAPTER2800EVERYONEWASSHOCKED from '@/components/99_chapter2800everyonewasshocked'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter2701giftbeforeparting",
 			"name" : "0_chapter2701giftbeforeparting",
 			"component" : A_CHAPTER2701GIFTBEFOREPARTING
 		},
 		{
 			"path" : "/1_chapter2702mysteriousskyevilemperor",
 			"name" : "1_chapter2702mysteriousskyevilemperor",
 			"component" : A_CHAPTER2702MYSTERIOUSSKYEVILEMPEROR
 		},
 		{
 			"path" : "/2_chapter2703confrontationforthesamerealm",
 			"name" : "2_chapter2703confrontationforthesamerealm",
 			"component" : A_CHAPTER2703CONFRONTATIONFORTHESAMEREALM
 		},
 		{
 			"path" : "/3_chapter2704achoiceofhelplessness",
 			"name" : "3_chapter2704achoiceofhelplessness",
 			"component" : A_CHAPTER2704ACHOICEOFHELPLESSNESS
 		},
 		{
 			"path" : "/4_chapter2705riskingoneslife",
 			"name" : "4_chapter2705riskingoneslife",
 			"component" : A_CHAPTER2705RISKINGONESLIFE
 		},
 		{
 			"path" : "/5_chapter2706strugglewithallyourmight",
 			"name" : "5_chapter2706strugglewithallyourmight",
 			"component" : A_CHAPTER2706STRUGGLEWITHALLYOURMIGHT
 		},
 		{
 			"path" : "/6_chapter2707heavenlysound",
 			"name" : "6_chapter2707heavenlysound",
 			"component" : A_CHAPTER2707HEAVENLYSOUND
 		},
 		{
 			"path" : "/7_chapter2708tibetandragoncrouchingtiger",
 			"name" : "7_chapter2708tibetandragoncrouchingtiger",
 			"component" : A_CHAPTER2708TIBETANDRAGONCROUCHINGTIGER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js